
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "120px",
    "height": "121px",
    "viewBox": "0 -0.5 120 121",
    "enable-background": "new 0 -0.5 120 121",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "display": "none",
        "fill": "#F2F2F2",
        "width": "120",
        "height": "120"
      }
    },
    {
      "tag": "polygon",
      "attrsMap": {
        "id": "XMLID_9_",
        "fill": "#FBDA73",
        "points": "77.333,22.5 90,34.832 90,102.5 30,102.5 30,22.5 "
      }
    },
    {
      "tag": "polygon",
      "attrsMap": {
        "id": "XMLID_8_",
        "fill": "#FFA84D",
        "points": "77.333,22.5 90,34.832 77.333,34.832 "
      }
    },
    {
      "tag": "polygon",
      "attrsMap": {
        "id": "XMLID_7_",
        "fill": "#E6E6E6",
        "points": "77.333,34.832 90,47.203 90,34.832 "
      }
    },
    {
      "tag": "rect",
      "attrsMap": {
        "id": "XMLID_6_",
        "x": "40.372",
        "y": "41.564",
        "fill": "#FDE9AB",
        "width": "39.254",
        "height": "2.907"
      }
    },
    {
      "tag": "rect",
      "attrsMap": {
        "id": "XMLID_5_",
        "x": "40.372",
        "y": "50.772",
        "fill": "#FDE9AB",
        "width": "39.254",
        "height": "2.907"
      }
    },
    {
      "tag": "rect",
      "attrsMap": {
        "id": "XMLID_4_",
        "x": "40.372",
        "y": "59.98",
        "fill": "#FDE9AB",
        "width": "39.254",
        "height": "2.906"
      }
    },
    {
      "tag": "rect",
      "attrsMap": {
        "id": "XMLID_3_",
        "x": "40.372",
        "y": "69.186",
        "fill": "#FDE9AB",
        "width": "39.254",
        "height": "2.907"
      }
    },
    {
      "tag": "rect",
      "attrsMap": {
        "id": "XMLID_2_",
        "x": "40.372",
        "y": "78.387",
        "fill": "#FDE9AB",
        "width": "39.254",
        "height": "2.914"
      }
    },
    {
      "tag": "rect",
      "attrsMap": {
        "id": "XMLID_1_",
        "x": "40.372",
        "y": "87.593",
        "fill": "#FDE9AB",
        "width": "39.254",
        "height": "2.915"
      }
    }
  ]
})
    }
  